
import { CompanyModule } from "@/models/company-module";
import { FormLike } from "winfakt-vue-components/src/mixins/form-like";
import {ElectronischeFacturatieMetaData} from "@/models/module-electronische-facturatie";
import { CompanyService } from "@/services/company-service";
import { Company } from "@/models/company";

export default FormLike.extend({
	data(){
		return {
			maxSents: 0,
			sentCount: 0,
			lastSentDate: new Date(0),
			useWfPeppol: false
		};
	},
	props: {
		value: {
			type: Object as ()=>CompanyModule,
			required: true
		},
		company: {
			type: Object as ()=>Company,
			required: true
		}
	},
	watch: {
		value: {
			immediate: true,
			handler(){
				let data = ElectronischeFacturatieMetaData.create(this.value.metaData);
				this.maxSents = data.getMaxPeppolSentsPerMonth();
				this.sentCount = data.getPeppolSentsThisMonth();
				this.lastSentDate = data.getLastPeppolSentDate();
				this.useWfPeppol = data.getUsesWinfaktPeppol();
			}
		}
	},
	methods: {
		cancel(){
			this.$emit("close");
		},
		async submit(){
			if (!this.isValid) return;
			ElectronischeFacturatieMetaData.create(this.value.metaData).setMaxPeppolSentsPerMonth(this.maxSents)
				.setPeppolSentsThisMonth(this.sentCount).setLastPeppolSentDate(this.lastSentDate).setUsesWinfaktPeppol(this.useWfPeppol);
			await CompanyService.updateModuleOfCompany(this.company, this.value.id, this.value.metaData);
			this.$emit("saved", this.value);
			this.$emit("close");
		}
	}
});
